import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from "./vuex";

Vue.use(Router);

const router = new Router({
	routes: [
		{
			path: "/",
			name: "home",
			component: Home
		},
		{
			path: "/dashboard",
			component: () => import("./views/Layout.vue"),
			beforeEnter(to, from, next) {
				if (!store.getters.isAuthenticated) {
					next("/");
				} else {
					next();
				}
			},
			children: [
				{
					path: "",
					name: "about",
					component: () => import("./views/Timer.vue")
				},
				{
					path: "projects",
					component: () => import("./views/Projects.vue"),
					children: [
						{
							path: "",
							name: "projects.list",
							component: () =>
								import("./views/Project/ProjectList.vue")
						},
						{
							path: "detail/:projectId",
							name: "projects.detail",
							component: () =>
								import("./views/Project/ProjectDetail")
						},
						{
							path: "add",
							name: "projects.add",
							component: () =>
								import("./views/Project/ProjectWizzard")
						}
					]
				},
				{
					path: "clients",
					component: () => import("./views/Clients.vue"),
					children: [
						{
							name: "clients.list",
							path: "",
							component: () => import("./views/Clients/ClientList")
						},
						{
							name: "clients.create",
							path: "create",
							component: () => import("./views/Clients/ClientCreate")
						},
						{
							path: "detail/:clientId",
							name: "clients.detail",
							component: () =>
									import("./views/Clients/ClientEdit"),
							children: [
								{
									path: "projects",
									name: "clients.detail.projects"
								}
							]
						},
					]
				},
				{
					path: "users",
					component: () => import("./views/Users.vue"),
					// beforeEnter(to, from, next) {
					// 	console.log(store);
					// 	if(store.state.account.user.type.id in [2,1]) {
					// 		next("/dashboard")
					// 	} else {
					// 		next();
					// 	}
					// },
					children: [
						{
							name: "users.list",
							path: "",
							component: () => import("./views/Users/UserList")
						},
						{
							name: "users.create",
							path: "create",
							component: () => import("./views/Users/UserCreate")
						},
						{
							path: "detail/:userId",
							name: "users.detail",
							component: () =>
									import("./views/Users/UserEdit")
						},
					]
				},
				{
					path: "stats",
					name: "stats",
					component: () => import("./views/Stats.vue")
				},
				{
					path: "settings",
					name: "settings",
					component: () => import("./views/Settings.vue")
				},
				{
					path: "calendar",
					name: "calendar",
					component: () => import("./views/Calendar.vue")
				},
				{
					path: "activities",
					component: () => import("./views/Activities"),
					children: [
						{
							name: "activities.edit",
							path: "edit/:id",
							component: () => import("./views/Activity/ActivityEdit")
						},
						{
							name: "activities.list",
							path: ":group",
							component: () => import("./views/Activity/Activities"),
						}
					]
				}
			]
		}
	],
	mode: "history"
});

export default router;
